import { getCurrentReleaseNote } from '../../shared/config/releaseNotes'
import { t } from '../../shared/config/translations'
import { getSettings, queueSettingsUpdate } from '../api/settings'
import { openSettingsSupportOverlay } from '../pages/settings/settingsSupportOverlay'
import initDialog from './Dialog'
import { releaseNotesDialogContentTemplate } from './releaseNotesTemplates'

let releaseNotesPromptChecked = false

export async function maybeShowReleaseNotesDialog(): Promise<void> {
	if (releaseNotesPromptChecked) return

	const currentReleaseNote = getCurrentReleaseNote()
	if (!currentReleaseNote) return

	const settings = await getSettings()
	if (!settings) return

	releaseNotesPromptChecked = true
	if (settings.lastSeenReleaseNotesId === currentReleaseNote.id) return

	initDialog({
		id: 'release-notes-dialog',
		cancelText: t('releaseNotes.later'),
		confirmText: t('releaseNotes.dismiss'),
		content: releaseNotesDialogContentTemplate(currentReleaseNote),
		onConfirm: () => markReleaseNoteSeen(currentReleaseNote.id),
		snackbarType: null,
		title: t('releaseNotes.dialogTitle'),
	})
	bindReleaseNotesSettingsLink(currentReleaseNote.id)
}

function bindReleaseNotesSettingsLink(releaseNoteId: string): void {
	document
		.querySelector<HTMLAnchorElement>('[data-release-notes-settings-link]')
		?.addEventListener('click', (event) => {
			event.preventDefault()
			void markReleaseNoteSeen(releaseNoteId)
			document
				.querySelector<HTMLDialogElement>('#release-notes-dialog')
				?.close()
			document
				.querySelector<HTMLDialogElement>('#release-notes-dialog')
				?.remove()
			openSettingsSupportOverlay('whats-new')
		})
}

async function markReleaseNoteSeen(releaseNoteId: string): Promise<void> {
	const latestSettings = await getSettings()
	if (!latestSettings) return
	queueSettingsUpdate({
		...latestSettings,
		lastSeenReleaseNotesId: releaseNoteId,
	})
}
